<script>
  import QRCode from "qrcode";
  export let invoice;

  const makeQR = async (data) => {
    try {
      return await QRCode.toDataURL(data, { margin: 0 });
    } catch (err) {
      console.error(err);
    }
  };
</script>

<section>
  {#await makeQR(invoice)}
    <p>Wait...</p>
  {:then qrw}
    <h3>Pague para finalizar</h3>
    <figure>
      <a href={`lightning:${invoice}`}>
        <img src={qrw} alt={invoice} />
      </a>
      <figcaption>{invoice}</figcaption>
    </figure>
  {:catch error}
    <p>Oh no! Something went wrong!</p>
  {/await}
</section>

<style>
  section {
    position: relative;
    padding: 1rem;
    margin: 0 auto;
  }
  figure {
    display: flex;
    flex-flow: column;
    align-items: center;
    margin: 0;
    margin-top: 2rem;
  }

  figure img {
    display: block;
    height: auto;
    max-width: 300px;
  }

  figcaption {
    margin-top: 2em;
    text-align: center;
    font-size: 75%;
    word-break: break-all;
    max-width: 300px;
  }
</style>
